export enum AberrantQuantityBulkActionModel {
	Delete = 1,
	Ignore = 2,
	Update = 3
}
